<template>
  <div class="changebns">
    <toptitle :title1="titlework" />
    <section class="menu">
      <div @click="showPopup1"
           class="choosedate">{{ deptDrop }}</div>
      <div @click="showPopup2"
           class="choosedate">
        {{levelres}}
      </div>
      <div @click="showPopup3"
           class="choosedate">
        {{ dateSearch | datefmt }}
      </div>
    </section>
    <!-- 部门-->
    <van-popup v-model="show1"
               position="bottom">

      <van-picker show-toolbar
                  :columns="columns1"
                  @confirm="onConfirm1"
                  @cancel="onCancel" />
    </van-popup>
    <van-popup v-model="show2"
               position="bottom">

      <van-picker show-toolbar
                  :columns="columns2"
                  @confirm="onConfirm2"
                  @cancel="onCancel" />
    </van-popup>
    <!--日期选择 -->
    <van-popup v-model="show3"
               position="bottom">
      <van-datetime-picker v-model="dateSearch"
                           type="year"
                           title="选择年份"
                           @confirm="onConfirm3"
                           :min-date="dateSearchMinDate"
                           :max-date="dateSearchMaxDate" />
    </van-popup>
    <div>
      <van-empty v-show="emptyShow"
                 description="暂无团队绩效" />
      <van-list class
                @load="loadMore"
                :finished="loadFinished"
                finished-text="没有更多了">
        <section class="fix"
                 v-for="(item,index) in dataList"
                 :key="index">
          <div @click="gotoachievement(item)"
               class="fix-divplay">

            <div class="divimg">
              <img class="img-carcle"
                   v-if="item.PHOTO != ''"
                   :src="`data:image/png;base64,${item.PHOTO}`"
                   alt="" />
              <div class="divnameone"
                   v-else>{{ item.NAME | cutName }}</div>
            </div>

            <div class="divInfo">
              <p class="divname">{{ item.NAME }}</p>
              <p>{{ item.POSN_DESCR }}</p>
            </div>
            <div class="divend"
                 style="line-height: 55px;">
              {{item.LEVEL}}
            </div>
          </div>
        </section>
      </van-list>
    </div>

    <loading-show :isLoadindShow="loading"></loading-show>
  </div>
</template>

<script>
import toptitle from '../components/toptitle'
import LoadingShow from '../components/loading'
import dateformat from '@/utils/dateformat'
import {
  getMyDeptDataApi,
  performanceDataApi,
  changeDataApi,
} from '../request/api'
export default {
  name: 'changebns',
  data() {
    return {
      titlework: '团队绩效',
      show1: false,
      show2: false,
      show3: false,
      emptyShow: false,
      loading: false,
      currentPageNo: 1,
      maxPageNo: 0,
      loading: false,
      loadFinished: false,
      columns1: [],
      columns2: [],
      columns3: [],
      department: [],
      levelResult: [],
      dataList: [],
      deptDrop: '部门',
      levelres: '绩效结果',
      dateSearch: '',
      dateSearchMinDate: new Date(2010, 1, 1), //年月范围中的最小值定义
      dateSearchMaxDate: new Date(), //年月范围中可选的最大值定义，在 created 中动态设置为当前月份
    }
  },
  mounted() {
    this.getDeptList()
  },
  methods: {
    showPopup1() {
      this.show1 = true
    },
    showPopup2() {
      this.show2 = true
    },
    showPopup3() {
      this.show3 = true
    },
    onConfirm1(value) {
      this.deptDrop = value
      this.show1 = false
      this.currentPageNo = 1
      this.dataList = []
      this.getData()
    },
    onConfirm2(value) {
      this.levelres = value
      this.show2 = false
      this.currentPageNo = 1
      this.dataList = []
      this.getData()
    },
    onConfirm3(value) {
      this.dateSearch = value
      this.currentPageNo = 1
      this.dataList = []
      this.show3 = false
      this.getData()
    },
    loadMore() {
      if (this.currentPageNo > this.maxPageNo) {
        //已经加载到了最后一页
        this.loadFinished = true
      } else {
        //加载下一页的数据
        this.currentPageNo++
        this.getData()
      }
    },
    /**
     * 部门获取
     * **/
    getDeptList() {
      let params = {
        EMPLID: sessionStorage.getItem('EMPLID'),
      }
      getMyDeptDataApi(params).then((res) => {
        if (res.CODE === 200) {
          this.department = res.DATA

          this.columns1 = this.department.map((item) => {
            return item.DEPT_DESCR
          })
          if (this.deptDrop == '部门') {
            this.deptDrop = this.department[0].DEPT_DESCR
          }
          this.getData()
        }
      })
    },

    onCancel() {
      this.show1 = false
      this.show2 = false
      this.show3 = false
    },

    gotoachievement(item) {
      this.$router.push({
        path: '/achievementsdel',
        query: item,
      })
    },
    /**
     * 获取部门绩效数据
     * **/
    getData() {
      this.loading = true
      let departOne = ''
      let emplid = ''
      this.department.forEach((element) => {
        if (this.deptDrop == element.DEPT_DESCR) {
          departOne = element.DEPTID
          emplid = element.EMPLID
        }
      })
      let level = ''
      this.levelResult.forEach((element) => {
        if (this.levelres == element.XLADSHORTNAME) {
          level = element.FIELDVALUE
        }
      })
      console.log(this.currentPageNo, 'this.currentPageNo')
      let params = {
        DEPTID: departOne,
        EMPLID: emplid,
        DATE: dateformat('yyyy', this.dateSearch),
        LEVEL: level,
        PAGE: this.currentPageNo.toString(),
        RECORD: 10,
      }
      performanceDataApi(params).then((res) => {
        if (res.CODE == 200) {
          let subBody = res.DATA.INFO

          this.maxPageNo = parseInt(res.DATA.MAXPAGE)
          if (this.currentPageNo >= this.maxPageNo) {
            this.loadFinished = true
          } else {
            this.loadFinished = false
          }
          if (this.currentPageNo == 1) {
            //如果当前是第一页，清空相关数据
            this.dataList = []
          }
          this.dataList = this.dataList.concat(subBody)

          this.dataList.forEach((item) => {
            item.PHOTO = item.PHOTO.replace(/<br>/g, '')
          })

          if (this.dataList == 0) {
            this.emptyShow = true
          } else {
            this.emptyShow = false
          }
          // console.log(this.dataList, 'dataList')
        }
        this.loading = false
      })
    },
  },
  components: {
    toptitle,
    LoadingShow,
  },
  filters: {
    datefmt(val) {
      //格式化日期查询条件的显示内容

      if (!val) return ''
      return dateformat('yyyy年', new Date(val))
    },
    cutName(val) {
      return val.slice(0, 1)
    },
  },
  created() {
    //能选择的最大年月为当前月份
    this.dateSearchMaxDate = new Date(dateformat('yyyy-MM-01'))

    //默认为当前月份
    this.dateSearch = new Date(dateformat('yyyy-MM-01'))
    let params2 = { FIELDNAME: 'C_PERF_LEVEL' } //绩效结果
    changeDataApi(params2).then((res) => {
      this.levelResult = res.DATA
      let allSelect = {
        XLADSHORTNAME: '全部',
        FIELDVALUE: '',
      }
      this.levelResult.unshift(allSelect)
      this.columns2 = this.levelResult.map((item) => {
        return item.XLADSHORTNAME
      })
    })
  },
}
</script>

<style lang="less" scoped>
.fix {
  background: white;
  margin: 10px 14px 0;
  padding: 12px 14px;
  color: #8f8f8f;
  line-height: 27px;
  font-size: 14px;

  .fix-divplay {
    display: flex;
    justify-content: flex-start;
    border-radius: 10px;
  }
  .fix-top {
    display: flex;
    .approve1 {
      background: #dbefe2;
      color: #4ab16d;
      width: 50px;
      height: 27px;
      text-align: center;
      border-radius: 10px;
    }
    .approve2 {
      background: #d9e5ff;
      color: #427cff;
      width: 50px;
      height: 27px;
      text-align: center;
      border-radius: 10px;
    }
    .approve3 {
      background: #e48e96;
      color: rgb(230, 3, 3);
      width: 50px;
      height: 27px;
      text-align: center;
      border-radius: 10px;
    }
    .number {
      text-align: right;
      flex: 1;
      span {
        color: black;
      }
    }
  }
}
.divimg {
  width: 55px;
  height: 55px;
  background: #55a0f8;
  box-sizing: border-box;
  border-radius: 50%;
  text-align: center;
  line-height: 55px;
  font-size: 18px;

  color: white;
}
.img-carcle {
  border-radius: 50%;
  width: 55px;
  height: 55px;
}
.divInfo {
  width: 60%;
  padding-left: 5%;
}

.menu {
  display: flex;
  border-top: 1px solid #e5e5e5;
  div {
    width: 50%;
    box-shadow: 0;
  }
  .choosedate {
    overflow: hidden;
    background: white;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #323233;
    font-size: 15px;
    border-left: 1px solid #e5e5e5;
  }
  .choosedate:after {
    display: inline-block;
    content: '';
    position: relative;
    top: 2px;
    margin-left: 3px;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-color: #999;
  }
}

/deep/.van-empty {
  background: #fff;
  border-top: 1px solid #e5e5e5;
}
</style>
